import type React from 'react'

import { cn } from '@mntn-dev/ui-utilities'

import {
  type UseFieldGridProps,
  useFieldGrid,
} from '../../hooks/use-field-grid.ts'

type FormLayoutProps = Readonly<
  {
    children: React.ReactNode
    className?: string
  } & UseFieldGridProps
>

const FormLayout = ({
  children,
  className,
  ...useFieldGridProps
}: FormLayoutProps) => {
  const { fieldGridClassName } = useFieldGrid({
    gap: '6',
    ...useFieldGridProps,
  })

  return (
    <div
      className={cn(
        fieldGridClassName,
        'in-[.qf-form-section]:gap-y-4',
        className
      )}
    >
      {children}
    </div>
  )
}

export { FormLayout, type FormLayoutProps }
